import { api } from 'services/api';
import {
  OmniUserResponse,
  OmiCasesResponse,
  OmniMessagesResponse
} from 'types';

interface CaseFilter {
  staff_id?: number;
  page: number;
}

export const omnideskApi = api
  .enhanceEndpoints({
    addTagTypes: ['OMNI_USERS']
  })
  .injectEndpoints({
    endpoints: (build) => ({
      getUsers: build.query<OmniUserResponse, void>({
        query: () => ({
          url: '/omnidesk/staff',
          method: 'GET'
        }),
        providesTags: ['OMNI_USERS']
      }),
      getCases: build.query<OmiCasesResponse, CaseFilter>({
        query: (params) => ({
          url: '/omnidesk/cases',
          method: 'GET',
          params: {
            ...params,
            limit: 10
          }
        })
      }),
      getMessages: build.query<OmniMessagesResponse, number>({
        query: (caseId) => ({
          url: `/omnidesk/cases/${caseId}/messages`,
          method: 'GET'
        })
      })
    })
  });
